module.exports = __webpack_public_path__ + "static/media/gem.1f456185.svg";